import { render, staticRenderFns } from "./handgrader_roster.vue?vue&type=template&id=bbf838de&scoped=true&"
import script from "./handgrader_roster.vue?vue&type=script&lang=ts&"
export * from "./handgrader_roster.vue?vue&type=script&lang=ts&"
import style0 from "./handgrader_roster.vue?vue&type=style&index=0&id=bbf838de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf838de",
  null
  
)

export default component.exports